import { TASK_TYPE } from "../../constants";

const initialState = {
  pencilModeColor: "black"
};

const pencilModeReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TASK_TYPE.CHANGE_PENCIL_MODE_COLOR:
      const { color } = payload;
      return { ...state, pencilModeColor: color };

    default:
      return { ...state };
  }
};

export default pencilModeReducer;
